import { useEffect } from 'react';
import useLoadable from '../use-loadable';
import getClient from './_get-client';

const useApiClient = ({ baseUrl, baseAuthUrl, yyy }) => {
  const { load, ...state } = useLoadable({
    callback: () => getClient({ baseUrl, baseAuthUrl, yyy }),
    actionPrefix: 'API_CLIENT'
  });

  useEffect(
    () => load(),
    [baseUrl, baseAuthUrl, yyy] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return state;
};

export default useApiClient;
